import React, { Component } from 'react';
import Stepper from '../../../components/Stepper';

import './add-students-flow.less'


class ProgressSteps extends Component {
  constructor(props) {
    super(props);
  }

  getStepperProps = () => {
    if (this.props.currentStep === 1)  {
      return (
        [
          { status: 'active', id: 'enterNames', label: 'Enter name(s)' },
          { status: 'disabled', id: 'selectGrade', label: 'Select grade' }
        ]

      )
    } else {  //This is step 2 out of 2
      return (
        [
          { status: 'completed', id: 'enterNames', label: 'Enter name(s)' },
          { status: 'active', id: 'selectGrade', label: 'Select grade' }
        ]
      )
    }
  }

  render() {
    return (
      <Stepper
        stepperProps={this.getStepperProps()}
      />
    )
  }
}

export default ProgressSteps;
